"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _SttCacheManager = _interopRequireDefault(require("../../../../SttCacheManager"));
var _SttHeading = _interopRequireDefault(require("../../../../SttTypography/SttHeading"));
var _menuUsuario = _interopRequireDefault(require("./menuUsuario"));
var _SttMenuItem = _interopRequireDefault(require("../../../../SttNavigation/SttMenuItem"));
var _SttListItemIcon = _interopRequireDefault(require("../../../../SttList/SttListItemIcon"));
var _SttListItemText = _interopRequireDefault(require("../../../../SttList/SttListItemText"));
var _navigationBar = _interopRequireDefault(require("./navigationBar"));
var _materialUiPopupState = _interopRequireWildcard(require("material-ui-popup-state"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Notifications = _interopRequireDefault(require("@material-ui/icons/Notifications"));
var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));
var _FileCopyOutlined = _interopRequireDefault(require("@material-ui/icons/FileCopyOutlined"));
var _ExitToAppOutlined = _interopRequireDefault(require("@material-ui/icons/ExitToAppOutlined"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _SttMenu = _interopRequireDefault(require("../../../../SttNavigation/SttMenu"));
var _cache = require("@stt-componentes/cache");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    cabecalho: {
      color: '#828282',
      height: "calc(".concat(theme.spacing(5), "px + 10px) !important"),
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    cabecalhoDesktop: {
      height: "".concat(theme.spacing(5), "px !important")
    },
    toolbar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: '0px',
      padding: '0'
    },
    nomeSistema: {
      color: theme.palette.text.primary,
      fontSize: '0.85rem',
      fontWeight: '400',
      textAlign: 'center',
      margin: '0 auto'
    },
    menuSobre: {
      right: 20,
      color: theme.palette.primary.main
    },
    botaoSair: {
      right: 10,
      color: theme.palette.primary.main
    },
    leftSection: {
      display: 'flex',
      alignItems: 'center'
    },
    centerSection: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap'
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto'
    }
  };
});
var HeaderDesktop = function HeaderDesktop(props) {
  var classes = useStyles();
  var config = props.config,
    redirectUrl = props.redirectUrl,
    nomeUsuario = props.nomeUsuario,
    modo = props.modo,
    headers = props.headers,
    opcoesDuvida = props.opcoesDuvida,
    strings = props.strings;
  var handleClickSair = function handleClickSair() {
    _cache.Autenticacao.logout(config)["finally"](function () {
      var message = {
        "acao": "LOGOUT"
      };
      _cache.Cache.setEventBus(message); // Envio global (safari não funciona)
      window.parent.postMessage(message, "*"); // Envio local 
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static",
    className: "".concat(classes.cabecalho, " ").concat(classes.cabecalhoDesktop)
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.leftSection
  }, (config === null || config === void 0 ? void 0 : config.url_base_oauth2) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_menuUsuario["default"], {
    config: config,
    nomeUsuario: nomeUsuario,
    strings: strings,
    headers: headers
  }), /*#__PURE__*/_react["default"].createElement(_SttCacheManager["default"], {
    config: config,
    redirectUrl: redirectUrl,
    modo: modo
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.centerSection
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h4",
    className: classes.nomeSistema
  }, config.instancia_nome)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.rightSection
  }, opcoesDuvida && /*#__PURE__*/_react["default"].createElement(_materialUiPopupState["default"], {
    variant: "popover"
  }, function (popupState) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: strings.opcoes
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
      disableRipple: true,
      size: "small",
      className: classes.menuSobre
    }, (0, _materialUiPopupState.bindTrigger)(popupState)), /*#__PURE__*/_react["default"].createElement(_Notifications["default"], null))), /*#__PURE__*/_react["default"].createElement(_SttMenu["default"], (0, _materialUiPopupState.bindMenu)(popupState), opcoesDuvida.onClickNotasAtualizacao && /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        opcoesDuvida.onClickNotasAtualizacao();
      }
    }, /*#__PURE__*/_react["default"].createElement(_SttListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Sort["default"], null)), /*#__PURE__*/_react["default"].createElement(_SttListItemText["default"], null, strings.notasAtualizacao)), /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), opcoesDuvida.onClickMateriaisSuporte && /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        opcoesDuvida.onClickMateriaisSuporte();
      }
    }, /*#__PURE__*/_react["default"].createElement(_SttListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_FileCopyOutlined["default"], null)), /*#__PURE__*/_react["default"].createElement(_SttListItemText["default"], null, strings.materiaisSuporte))));
  }), (config === null || config === void 0 ? void 0 : config.url_base_oauth2) && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: strings.logout
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    className: classes.botaoSair,
    onClick: handleClickSair
  }, /*#__PURE__*/_react["default"].createElement(_ExitToAppOutlined["default"], null)))))), /*#__PURE__*/_react["default"].createElement(_navigationBar["default"], props));
};
var _default = HeaderDesktop;
exports["default"] = _default;